import { formatNumber } from 'utils/numberFormat';
import { HTMLAttributes, memo, useMemo, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { DownOutlined } from '@ant-design/icons';
import { getLazadaIncomeLabel } from 'services/i18n/enum/order';
import Fold from './Fold';
import { DetailItem, Amount, Detail, priceRender } from './TradeDetailPaymentLazada';
import { LIHeaderChild } from './LIHeaderChild';

export interface TradeIncomeAmountProps extends HTMLAttributes<HTMLElement> {
  trade: Conversation.Trade.Vo;
  defaultFold?: boolean;
}

/** shopee 买家实付金额 */
function TradeDetailIncomeLazada(props: TradeIncomeAmountProps) {
  const { trade, defaultFold = true, className, ...otherProps } = props;

  const { unit, customTradeIncome } = trade;

  const { GrandTotal, lastCustomTradeIncome } = useMemo(() => {
    const index = customTradeIncome.findIndex((item) => item.name === 'Grand Total');
    const GrandTotal = customTradeIncome[index];
    const lastCustomTradeIncome = [...customTradeIncome];
    index !== undefined && lastCustomTradeIncome.splice(index, 1);
    return {
      lastCustomTradeIncome,
      GrandTotal: GrandTotal || { price: 0 },
    } as const;
  }, [customTradeIncome]);

  const { t } = useTranslate();

  const [isfold, setIsfold] = useState(defaultFold);

  const total = priceRender(GrandTotal.price, (val) => {
    return (
      <DetailItem
        key="total"
        onClick={() => setIsfold((isfold) => !isfold)}
        style={
          className === 'tradeDetail'
            ? {
                border: '1px solid var(--fett-border-default)',
                padding: '0 16px',
                lineHeight: '40px',
              }
            : {}
        }
      >
        <span style={className === 'tradeDetail' ? { fontWeight: 'bold' } : {}}>
          {t('domain.order.income.field.grandTotal')}
        </span>
        {className !== 'tradeDetail' ? (
          <Amount isfold={isfold}>
            <div>{`${unit} ${formatNumber(val, '0,0.00')}`}</div>
            <DownOutlined />
          </Amount>
        ) : null}
      </DetailItem>
    );
  });

  const detail = (
    <Detail
      key="detail"
      style={
        className === 'tradeDetail'
          ? {
              background: 'none',
              border: '1px solid var(--fett-border-default)',
              borderTop: 'none',
            }
          : {}
      }
    >
      {lastCustomTradeIncome.map((item) => {
        return (
          <LIHeaderChild key={item.name}>
            <dt>{getLazadaIncomeLabel(t, item.name)}</dt>
            <dd className="colorFont">{`${unit} ${formatNumber(item.price, '0,0.00')}`}</dd>
          </LIHeaderChild>
        );
      })}
      {priceRender(GrandTotal.price, (val) => {
        return (
          <li>
            <dt>{`${t('domain.order.income.field.grandTotal')}`}</dt>
            <dd className="colorFont">{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
    </Detail>
  );

  return total ? (
    <Fold
      isfold={isfold}
      fixedCount={1}
      nodeList={[total, detail]}
      defaultFixedHeight={32}
      {...otherProps}
      style={className === 'tradeDetail' ? { marginBottom: '16px' } : {}}
    />
  ) : null;
}

export default memo(TradeDetailIncomeLazada);
